import * as React from 'react';
import { useGroundingMenuSearchBox_unstable } from './useGroundingMenuSearchBox';
import { renderGroundingMenuSearchBox_unstable } from './renderGroundingMenuSearchBox';
import { useGroundingMenuSearchBoxStyles_unstable } from './useGroundingMenuSearchBoxStyles.styles';
import type { GroundingMenuSearchBoxProps } from './GroundingMenuSearchBox.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingMenuSearchBox component - TODO: add more docs
export const GroundingMenuSearchBox: ForwardRefComponent<GroundingMenuSearchBoxProps> = React.forwardRef(
  (props, ref) => {
    const state = useGroundingMenuSearchBox_unstable(props, ref);

    useGroundingMenuSearchBoxStyles_unstable(state);
    return renderGroundingMenuSearchBox_unstable(state);
  },
);

GroundingMenuSearchBox.displayName = 'GroundingMenuSearchBox';
